import axios from 'axios';
import ethereum from 'decentralized/ethereum.js';
import React, { Component } from 'react';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

class SoundTagger extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tags: []
        };
        this._tag = '';

        this.addListener();
    }

    addListener() {
        window.addEventListener('sound_selected', () => {
            if (this.input) {
                if (this.input !== document.activeElement) { 
                    this.input.focus();
                }
            }
        });
    }

    addTag() {
        this.state.tags.push(this._tag);
        var self = this;
        self.props.onUpdateTags(this._tag);
        this._tag = '';
        this.setState(this.state);
    }

    onInputType(value) {
        this._tag = value;
        this.setState(this.state);
    }

    onKeyPress(e) {
        if (e.key === 'Enter') {
            this.addTag();
        }
    }

    render() {
        return (<div className="tag-editor">
                {this.props.soundUploadMode ? '' : <div onClick={this.props.onClickBack} className="light-blue-button common-button">Back to search</div>}
                <div className="tags">
                   <InputGroup>
                <div>
                <input
                type="text"
                ref={(input) => this.input = input}
                autoFocus onKeyPress={(e) => this.onKeyPress(e)} value={this._tag} id="search-input" onChange={(event) => this.onInputType(event.target.value)} placeholder="Enter tag name" className="tag-discover-input"/>
                </div>
                        <InputGroupAddon addonType="append">
                        <Button onClick={() => this.addTag()} color="secondary">Tag</Button>
                        </InputGroupAddon>
                        </InputGroup>
                </div>
                </div>);
    
    }
}

export default SoundTagger;
